<template>
  <div class="user-overview-tabs">
    <div class="user-overview-tabs__tabs no-print" v-if="tabs.length > 1">
      <Tabs
        :tabs="tabs"
        :selected="activeView"
        :isLarge="true"
        @select="theView = $event">
      </Tabs>
    </div>
    <TaskOverviewPage
      v-if="activeView === 'tasks'"
      :user_id="user.id"
      :user_calendar_id="user.user_calendar_id"
      :user_name="user.name"
      :isCanSeeOtherUsers="false">
    </TaskOverviewPage>
    <UserTasks
      v-else
      :user_id="user.id"
      :user_calendar_id="user.user_calendar_id"
      :user_name="user.name"
      :initialStartDate="initialStartDate"
      :initialEndDate="initialEndDate"
      :initialIsShowScheduled="initialIsShowScheduled"
      :isShowPrintButton="true"
      :isCanSeeOtherUsers="false">
    </UserTasks>
  </div>
</template>

<script>
import Tabs from '../common/Tabs'
import TaskOverviewPage from './TaskOverview/TaskOverviewPage'
import UserTasks from './UserTasks'

// Viser Opgaveoversigt og Timeopgørelse for en medarbejder med tabs, fx i modaler i Årsnorm og Fagfordeling
export default {
  components: {Tabs, TaskOverviewPage, UserTasks},
  props: {
    user: {
      type: Object,
      required: true
    },
    initialView: {
      type: String,
      default: 'hours'
    },
    initialStartDate: {
      default: null
    },
    initialEndDate: {
      default: null
    },
    initialIsShowScheduled: {
      default: null
    }
  },
  data () {
    return {
      theView: this.initialView
    }
  },
  computed: {
    loggedInUser () {
      return this.$store.state.user
    },
    isOwnUser () {
      return !!this.loggedInUser && (this.loggedInUser.id * 1) === (this.user.id * 1)
    },
    canSeeTaskOverview () {
      if (this.isOwnUser && this.userHasPermission('can_see_own_task_overview')) {
        return true
      }
      return this.userHasPermission('can_see_others_task_overviews')
    },
    tabs () {
      const tabs = []
      if (this.canSeeTaskOverview) {
        tabs.push({id: 'tasks', title: this.$t('vue2.task_overview.task_overview')})
      }
      tabs.push({id: 'hours', title: this.$store.getters.isKindergarten ? 'Årsnormsoversigt' : this.$t('vue2.task_overview.hour_overview')})
      return tabs
    },
    activeView () {
      return this.tabs.some(tab => tab.id === this.theView) ? this.theView : 'hours'
    }
  },
  methods: {
    userHasPermission (permission) {
      if (!this.loggedInUser) {
        return false
      }
      if (this.$store.getters.isPermissionsActivatedForSchool) {
        return this.$store.getters.userPermissions.indexOf(permission) > -1 || this.loggedInUser.admin
      }
      return true
    }
  }
}
</script>

<style scoped>
.user-overview-tabs__tabs {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// UserOverviewTabs.vue?e751ea7a